<script>
  import Conexoes from "../Classes/Conexoes";
  import Constantes from "../Classes/Constantes";
  import { ItemInserir, Tipo } from "../Classes/ItemInserir";
  import InserirDadosBasico from "../Componentes/InsercaoDados/InserirDadosBasico.svelte";
  import CaixaDeDialogo from "./CaixaDeDialogo.svelte";
  
    import ModalConfirmaToken from "./ModalConfirmaToken.svelte";
        import {
    permissaoUsuario,
    permissaoPlataforma,
    DadosGenericos,
    DadosPaginaAnterior,
    DadosLogin
  } from '../Classes/Stores';
    
  export let showModal = true;
  let msgConfirmacao;
  let token;
  const apiInsercao = Constantes.api_cadastrar_usuario;

  const query_code_inserir = Constantes.query_code_cadastrar_novo_usuarios;

  const itens = [
    new ItemInserir({
      rotulo: "Nome",
      nomeColuna: "nome_usuario",
      tamanho: 200,
      tipo: Tipo.NOME_SOBRENOME,
      obrigatorio: true,
    }),
    new ItemInserir({
      rotulo: "Email",
      nomeColuna: "email",
      tamanho: 100,
      tipo: Tipo.EMAIL_CONFIRMA,
      obrigatorio: true,
    }),
    new ItemInserir({
      rotulo: "CPF",
      nomeColuna: "cpf",
      tamanho: 20,
      tipo: Tipo.CPF,
      obrigatorio: false,
    }),
    new ItemInserir({
      rotulo: "Data de nascimento",
      nomeColuna: "data_nascimento",
      tamanho: 10,
      tipo: Tipo.DATA,
      obrigatorio: true,
    }),
    new ItemInserir({
      rotulo: "Telefone (apenas DDD e número)",
      nomeColuna: "telefone", 
      tamanho: 11,
      tipo: Tipo.TELEFONE,
      obrigatorio: true,
    }),

    new ItemInserir({
      rotulo: "Senha",
      nomeColuna: "senha",
      tamanho: 30,
      tipo: Tipo.PASSWORD,
      obrigatorio: true,
    }),

    new ItemInserir({
      rotulo: "Gênero",
      nomeColuna: "genero",
      tamanho: 30,
      tipo: Tipo.SELECAO,
      config_drop_down: {
        nome_coluna_saida: "genero",
        filtravel: true,
        itens: ["Masculino", "Feminino", "Outro"],
      },
    }),

    new ItemInserir({
      rotulo: "Assessoria",
      nomeColuna: "assessoria",
      tamanho: 30,
      tipo: Tipo.DROPSELECAO,
      obrigatorio: true,
      config_selecao: {
        api: Constantes.api_consultar_padrao,      
        query_code: Constantes.query_code_consulta_assessorias,
        campos_pesquisaveis: ["Assessoria"],
        colunas_exibidas: ["Assessoria"],
        coluna_saida: "id",
        titulo: "Selecione a(as) assessoria(as) que você faz parte",
        filtravel: true,
        itens: "",
      },
    }),
  ];

  function Sucesso() {

 showModal=false;
    // //console.log("dispac",e)
    //if(e.detail==true){
    //   
    // }
  }

  function Reenviar(){



  }
function NaoConfirmado(){
  msgConfirmacao = "Token inválido, digite novamente ou clique em reenviar código"
}
  function ChamarConfirmacao() {
    //console.log("chamando confirmacao")
    showModal=false;
    msgConfirmacao =
      "Um sms foi enviado ao seu telefone com um token. Digita o token para confirmar dados!";
  }
 
  let conexao = new Conexoes();
  let resultado;
  let api = "consultas.php";
  let parametros;
  let carregando = false;
  async function ConfirmaToken() {
    carregando = true;
    resultado = new Conexoes(api, {
      query_code: "confirma_token",
      token: token,
    });
    carregando = false;

    let confirmou = false;
    if (resultado) {
      if (resultado[0]) {
        if (resultado[0].id) {
          confirmou = true;
        }
      }
    }
    if (confirmou) {
      Sucesso();
    }else{
      NaoConfirmado();
    }
  }
</script>



{#if showModal}
  <div class="modal">
    <div class="modal-content">
    <button class="close" on:click={() => showModal = false}>&times;</button>
      <InserirDadosBasico
      naoConfirma={true}
        on:finalizado_sucesso={()=>ChamarConfirmacao()}
        msgSucesso={"Cadastrado com sucesso. Enviamos ao seu email um pedido de confirmação. Confirme o email e em seguida efetue o login!"}
        titulo={"Cadastre-se"}
        tituloBotaoEnviar={"Cadastrar"}
        api={apiInsercao}
        {itens}
        {query_code_inserir}
      >
        <div class="mb-3 mt-2 padraoAviso">
          <i
            >Ao clicar no botão abaixo significa que você concorda com o <a
              href="{Constantes.url_base+"privacidade.html"}"
              target="_blank"
              >Termos de uso, política de privacidade e cookies</a
            > da Plataforma FitPace.
          </i>
        </div>
      </InserirDadosBasico>
    </div>
  </div>
{/if}
{#if msgConfirmacao}
<ModalConfirmaToken showModal={msgConfirmacao} email={$DadosGenericos.email} />
{/if}
<style>
  .modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  border-radius: 10px;
  max-height: 80%;
  overflow-y: auto;
}

.modal-body {
  max-height: calc(100% - 40px); /* Ajuste para o padding */
  overflow-y: auto;
}

.close {
  color: #aaa;
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  font-weight: bold;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.close:hover {
  color: #000;
}







</style>
